import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IAssessScreen } from '../../../../shared/models/assessScreen';
import { IUser, IThreatAssessmentTeam } from '../../../../shared/models/contact';
import { ContactsService } from '../../../../shared/services/contact.service';
import { UserDataService } from '../../../../shared/services/auth/userData.service';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';

@Component({
  selector: 'official-signature',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SpinnerComponent
  ],
  templateUrl: './official-signature.component.html',
  styleUrl: './official-signature.component.css'
})
export class OfficialSignatureComponent implements OnInit, AfterViewInit, OnChanges {

  currentDate = new Date();
  signatureForm: FormGroup = new FormGroup([]);
  
  currentCaseId: string | null = null;
  currentBuildingId: string | null = null;
  currentContact: IThreatAssessmentTeam | null = null;
  messageModal: string | null = null;

  loading: boolean = false;
  
  @Input() assessScreenData: any;
  @Output() onSaveSection4 = new EventEmitter<IAssessScreen>();

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private contactsService: ContactsService,
    private userDataService: UserDataService
  ) {}

  ngOnInit() {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.currentContact = this.userDataService.getCurrentUser();
    
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['assessScreenData'] && this.assessScreenData) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    this.signatureForm = new FormGroup({
      user_signature_name: new FormControl('', Validators.required),
    });
  }

  async ngAfterViewInit(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
    }
  }

  saveSignature(): void {
    if (this.signatureForm.valid) {
        this.onSaveSection4.emit(this.signatureForm.value);
    }
  }

}
